import { render, staticRenderFns } from "./indexActivityNewest.vue?vue&type=template&id=e215fc40&scoped=true&"
import script from "./indexActivityNewest.vue?vue&type=script&lang=js&"
export * from "./indexActivityNewest.vue?vue&type=script&lang=js&"
import style0 from "./indexActivityNewest.vue?vue&type=style&index=0&id=e215fc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e215fc40",
  null
  
)

export default component.exports